import { Bar, BarConfig } from '@ant-design/plots';
import { useQuery } from '@apollo/client';
import { GET_TRENDING_REGION, TrendingRegions } from '@frontend/data-access';
import { Card } from 'antd';
import useTranslation from 'next-translate/useTranslation';

function TrendingRegionStats() {
  const { t } = useTranslation('admin');
  const { data, loading } = useQuery<{
    dashboardTrendingRegions: TrendingRegions[];
  }>(GET_TRENDING_REGION);

  const COLOR_PLATE_10 = [
    '#0273EA',
    '#00CC00',
    '#B1BDC9',
    '#7AC4FC',
    '#C5F1BB',
    '#A3B1BF',
    '#8B8B8B',
    '#1890FF',
  ];

  const config: BarConfig = {
    data: data?.dashboardTrendingRegions ?? [],
    loading,
    isStack: true,
    xField: 'value',
    yField: 'name',
    seriesField: 'type',
    legend: { position: 'bottom', flipPage: false },
    xAxis: {
      label: {
        style: {
          fontFamily: 'Lufga',
        },
      },
    },
    yAxis: {
      label: {
        style: {
          fontFamily: 'Lufga',
        },
      },
    },
    label: {
      text: ({ value }) => (value > 0 ? value : ''),
      textBaseline: 'bottom',
      position: 'inside',
      style: {
        fill: 'rgba(255, 255, 255, 1)',
        fontFamily: 'Lufga',
      },
    },
    scale: {
      color: {
        range: COLOR_PLATE_10,
      },
    },
  };

  return (
    <Card
      style={{
        borderRadius: 20,
      }}
    >
      <div className="space-y-5">
        <div className="text-sm text-gray-900 font-medium">
          {t('trending_region_stats')}
        </div>
        <Bar {...config} />
      </div>
    </Card>
  );
}

export default TrendingRegionStats;
